import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex space-x-4 mb-5" }
const _hoisted_2 = { class: "w-10 h-10 rounded-full mx-auto bg-primary-300 flex justify-center items-center flex-shrink-0" }
const _hoisted_3 = { class: "w-full text-left" }
const _hoisted_4 = { class: "text-neutral-600 font-medium text-sm" }
const _hoisted_5 = { class: "mt-6" }
const _hoisted_6 = { class: "mt-6 text-center" }

import {
  DialogTitle,
} from '@headlessui/vue';
import BaseModal from '@/components/modals/BaseModal.vue';
import ButtonComponent from '@/components/buttons/ButtonComponent.vue';
import { QuestionMarkCircleIcon } from '@heroicons/vue/24/solid';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckModal',
  props: {
    show: {
        type: Boolean
    },
    title: {
        type: String,
    },
    description: {
        type: String,
    },
    actionText: {
        type: String,
    },
    customClass: {
        type: String,
        default: 'w-[570px] py-6 px-11 min-w-[480px] max-h-[80vh]'
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    customClass: __props.customClass,
    show: __props.show
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(QuestionMarkCircleIcon), { class: "w-5 h-5 text-primary-600 mx-auto" })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(DialogTitle), {
            as: "p",
            class: "text-xl font-bold mb-1"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.title), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", _hoisted_4, _toDisplayString(__props.description), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "content")
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(ButtonComponent, {
          btnWidth: "quinary rounded",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('confirm')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.actionText), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 3
  }, 8, ["customClass", "show"]))
}
}

})